import {
  query_project_price_change_record_list,
  delete_project_price_change_record,
  update_project_price_change_record,
  create_project_price_change_record,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-projectpricechangerecord-config';

import { reactive } from 'vue';
import { get_is_active, getDateTime } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目',
      disabled: false,
      placeholder: '请选择项目',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    project_id: null,
    is_active: true,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目',
      disabled: false,
      placeholder: '请选择项目',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'number',
      name: 'after_price',
      label: '预计变更价格',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写预计变更价格',
    },
    {
      type: 'datepicker',
      name: 'plan_date',
      label: '预计变更时间',
      disabled: false,
      allowClear: true,
      defaultValue: '',
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      showTime: false,
      placeholder: '预计变更时间',
    },
    {
      type: 'textarea',
      name: 'reason',
      label: '变动原因',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      maxlength: 300,
      defaultValue: '',
      placeholder: '请填写变动原因',
    },
  ],
  rules: {
    project_id: [{ required: true, message: '请选择项目' }],
    after_price: [{ required: true, message: '请填写预计变更价格' }],
    plan_date: [{ required: true, message: '请选择预计变更时间' }],
  },
  model: reactive({
    org_id: current_org?.id,
    project_id: null,
    after_price: null,
    plan_date: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'project__name',
      label: '产品编码',
      disabled: true,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
    },
    {
      type: 'number',
      name: 'after_price',
      label: '预计变更价格',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写预计变更价格',
    },
    {
      type: 'datepicker',
      name: 'plan_date',
      label: '预计变更时间',
      disabled: false,
      allowClear: true,
      defaultValue: '',
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      showTime: false,
      placeholder: '预计变更时间',
    },
    {
      type: 'textarea',
      name: 'reason',
      label: '变动原因',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      maxlength: 300,
      defaultValue: '',
      placeholder: '请填写变动原因',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    after_price: null,
    plan_date: null,
    project_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '项目价格变动记录管理',
  addModalTitle: '新建项目价格变动记录',
  updateTitle: '修改项目价格变动记录',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
    project_price_change_record_id: 'id',
  },
  delete: {
    project_price_change_record_id: 'id',
  },
  recover: {
    project_price_change_record_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    project_price_change_record_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '项目名称',
    dataIndex: 'project__name',
    checked: true,
  },
  {
    title: '变动前价格',
    dataIndex: 'before_price',
    checked: true,
  },
  {
    title: '变动后价格',
    dataIndex: 'after_price',
    checked: true,
  },
  {
    title: '预计变更时间',
    dataIndex: 'plan_date',
    checked: true,
  },
  {
    title: '变动原因',
    dataIndex: 'reason',
    checked: true,
  },
  {
    title: '创建日期',
    dataIndex: 'create_time',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '是否可用',
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'boolean',
    name1: '可用',
    name2: '禁用',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active(text);
    },
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_project_price_change_record_list,
    addData: create_project_price_change_record,
    updateData: update_project_price_change_record,
    removeData: delete_project_price_change_record,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
